<template>

    <CobaltDashboard :info="null" :company="null" :withFilterBar="false" contentClasses="single ps-0 pe-0">

        <div class="np-home">

            <Navigation :activeTab="activeScreen" @callSwitchScreen="callSwitchScreen"/>

            <AdminTab
                v-if="this.activeScreen == 'admin'"
                @switchScreen="switchScreen"            
            ></AdminTab>

            <OrganizationTab
                v-if="this.activeScreen == 'organization'"
                @switchScreen="switchScreen"            
            ></OrganizationTab>    
            
            <UsersTab
                v-if="this.activeScreen == 'users'"
                @switchScreen="switchScreen"            
            ></UsersTab>    
            
            <LogsTab
                v-if="this.activeScreen == 'logs'"
                @switchScreen="switchScreen"            
            ></LogsTab>                
        </div>

    </CobaltDashboard>

</template>

<script>

import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import Navigation from '@/components/admin/Navigation.vue';
import AdminTab from "@/components/admin/Admin.vue"
import OrganizationTab from "@/components/admin/Organization.vue"
import UsersTab from "@/components/admin/Users.vue"
import LogsTab from "@/components/admin/Logs.vue"

export default {
    components: {
        CobaltDashboard,
        Navigation,
        AdminTab,
        OrganizationTab,
        UsersTab,
        LogsTab
    },
    data() {
        return {
            activeScreen: "admin"
        }
    },
    beforeMount: function () {
        //this.getListComp()
    },
    computed: {            
    },
    methods: {
        callSwitchScreen(target) {
            this.activeScreen = target
        },   
    }

}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
    }
    .shelf {
        flex: 1 1 auto;
        width: 100%;
        margin-bottom: 10px;
        border: none;
        background-color: transparent;
        display: flex;
        flex-direction: row;
        font-size: 13px;
    }
    .shelf:last-child {
        margin-bottom: 0;
    }
    .labelbox {
        flex: 0 0 70%;
    }
    .valuebox {
        flex: 0 0 10%;
    }
    .valuebox img {
        width: 24px;
        opacity: .8;
    }
    .command-user__list-title.shelf {
        font-size: 14px;
        font-weight: 500;
    }
    .stats-select-date {
        padding: 10px 20px;
        font-size: 12px;
        background-color: #FFF;
        border: 10px;
        border-width: 0;
        box-shadow: 0 3px 5px rgb(0 0 0 / 4%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>